import { Directive, HostListener, Input } from '@angular/core';
import { AppLauncher } from '@capacitor/app-launcher';
import { ActionSheetController, Platform } from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core';
import { TranslateService } from '@ngx-translate/core';

enum MapApps {
  AppleMaps,
  GoogleMaps
}

interface Coordinates {
  latitude: string | number;
  longitude: string | number;
}

@Directive({
  selector: '[scLaunchNavigator]',
  standalone: false
})
export class LaunchNavigatorDirective {
  @Input('coordinates') location: Coordinates;

  constructor(
    private readonly actionSheetCtrl: ActionSheetController,
    private readonly platform: Platform,
    private readonly translate: TranslateService
  ) {}

  @HostListener('click') async onClick(): Promise<void> {
    if (this.platform.is('android')) {
      this.openApp(MapApps.GoogleMaps, this.location);
    } else {
      const actionSheet = await this.actionSheetCtrl.create({
        header: this.translate.instant('NAVIGATOR.OPEN_IN'),
        buttons: [
          {
            text: 'Google Maps',
            data: {
              action: MapApps.GoogleMaps
            }
          },
          {
            text: 'Apple Maps',
            data: {
              action: MapApps.AppleMaps
            }
          }
        ]
      });

      actionSheet.onDidDismiss().then((event: OverlayEventDetail) => {
        this.openApp(event.data.action, this.location);
      });

      await actionSheet.present();
    }
  }

  private async openApp(app: MapApps, location: Coordinates): Promise<void> {
    const coords = [location.latitude, location.longitude].join(',');
    let url;

    if (app === MapApps.AppleMaps) {
      url = `https://maps.apple.com/?daddr=${coords}`;
    } else if (app === MapApps.GoogleMaps) {
      url = `https://maps.google.com/?daddr=${coords}&directionsmode=driving`;
    }

    await AppLauncher.openUrl({ url });
  }
}
